import React from 'react';
import { Button, Icon } from '@chakra-ui/react';
import { useDownloadFile } from 'hooks/useDownloadFile';
import { PermissionsGate } from 'components';
import { CAN_GENERATE_PROPOSAL_REPORT } from 'consts/permissions';
import { DownloadIcon } from '@chakra-ui/icons';
import { useTranslation } from 'react-i18next';

const CampaignReportDownloadButton = ({
  campaignId,
}: {
  campaignId: string;
}): JSX.Element => {
  const { t } = useTranslation();
  const { mutate, isLoading } = useDownloadFile();

  const handleDownload = () => {
    mutate({
      url: `/campaign/${campaignId}/report`,
      fileName: `campaign-${campaignId}-report`,
    });
  };

  return (
    <PermissionsGate requiredPermissions={[CAN_GENERATE_PROPOSAL_REPORT]}>
      <Button
        leftIcon={<Icon as={DownloadIcon} />}
        variant='secondary'
        onClick={handleDownload}
        isLoading={isLoading}
      >
        {isLoading
          ? t('downloading', 'Pobieranie...')
          : t('downloadCampaignReport', 'Pobierz mediaplan')}
      </Button>
    </PermissionsGate>
  );
};

export default CampaignReportDownloadButton;
